import React from 'react';
import {useSelector} from 'react-redux';

import InfoButton from '~/frontend/src/components/base/page/PageMenu/InfoButton';
import LanguageButton from '~/frontend/src/components/base/page/PageMenu/LanguageButton';
import QuickSearchField from '~/frontend/src/components/base/page/PageMenu/QuickSearchField';
import UserButton from '~/frontend/src/components/base/page/PageMenu/UserButton';

import {StoreState} from '~/frontend/src/store';


/**
 * page menu
 * @return {JSX.Element}
 * @constructor
 */
const PageMenu = () => {
    const user = useSelector( ( state : StoreState ) => state.session?.user );

    if ( user ) {
        return <>
            <QuickSearchField
                className="mr-1"
            />
            <LanguageButton
                className="ml-1"
            />
            <UserButton
                className="ml-1"
            />
            <InfoButton
                className="ml-1"
            />
        </>;
    }
    else {
        return <></>;
    }
}

export default PageMenu;
